import {Routes} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';
import {AuthGuard} from './guards/auth.guard';


export const AppRoutes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard/default',
        pathMatch: 'full'
      }, {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      }, {
        path: 'widget',
        loadChildren: () => import('./pages/widget/widget.module').then(m => m.WidgetModule)
      }, {
        path: 'basic',
        loadChildren: () => import('./pages/ui-elements/basic/basic.module').then(m => m.BasicModule)
      }, {
        path: 'advance',
        loadChildren: () => import('./pages/ui-elements/advance/advance.module').then(m => m.AdvanceModule)
      }, {
        path: 'animations',
        loadChildren: () => import('./pages/animations/animations.module').then(m => m.AnimationsModule)
      }, {
        path: 'forms',
        loadChildren: () => import('./pages/ui-elements/forms/forms.module').then(m => m.FormsModule)
      }, {
        path: 'bootstrap-table',
        loadChildren: () => import('./pages/ui-elements/tables/bootstrap-table/bootstrap-table.module').then(m => m.BootstrapTableModule),
      }, {
        path: 'data-table',
        loadChildren: () => import('./pages/ui-elements/tables/data-table/data-table.module').then(m => m.DataTableModule),
      }, {
        path: 'charts',
        loadChildren: () => import('./pages/charts/charts.module').then(m => m.ChartsModule),
      }, {
        path: 'map',
        loadChildren: () => import('./pages/map/map.module').then(m => m.MapModule),
      }, {
        path: 'maintenance/error',
        loadChildren: () => import('./pages/maintenance/error/error.module').then(m => m.ErrorModule)
      }, {
        path: 'maintenance/coming-soon',
        loadChildren: () => import('./pages/maintenance/coming-soon/coming-soon.module').then(m => m.ComingSoonModule)
      }, {
        path: 'user',
        loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule)
      }, {
        path: 'crm-contact',
        loadChildren: () => import('./pages/ui-elements/crm-contact/crm-contact.module').then(m => m.CrmContactModule)
      }, {
        path: 'task',
        loadChildren: () => import('./pages/task/task.module').then(m => m.TaskModule)
      }, {
        path: 'editor',
        loadChildren: () => import('./pages/ui-elements/editor/editor.module').then(m => m.EditorModule)
      }, {
        path: 'invoice',
        loadChildren: () => import('./pages/invoice/invoice.module').then(m => m.InvoiceModule)
      }, {
        path: 'file-upload',
        loadChildren: () => import('./pages/ui-elements/file-upload/file-upload.module').then(m => m.FileUploadUIModule)
      }, {
        path: 'change-log',
        loadChildren: () => import('./pages/change-log/change-log.module').then(m => m.ChangeLogModule)
      }, {
        path: 'simple-page',
        loadChildren: () => import('./pages/simple-page/simple-page.module').then(m => m.SimplePageModule)
      }, 
      {
        path: 'schedule',
        loadChildren: () => import('./pages/job-schedule/job-schedule.module').then(m => m.JobScheduleModule)
      },
      {
        path: 'joblist',
        loadChildren: () => import('./pages/job-list/job-list.module').then(m => m.JobListModule)
      },
      {
        path: 'jobview',
        loadChildren: () => import('./pages/job-view/job-view.module').then(m => m.JobViewModule)
      },
      {
        path: 'jobcomposer',
        loadChildren: () => import('./pages/job-composer/job-composer.module').then(m => m.JobComposerModule)
      },
      {
        path: 'invoicelist',
        loadChildren: () => import('./pages/invoice-list/invoice-list.module').then(m => m.InvoiceListModule)
      },
      {
        path: 'invoicepage',
        loadChildren: () => import('./pages/invoice-page/invoice-page.module').then(m => m.InvoicePageModule)
      },
      {
        path: 'sysusers',
        loadChildren: () => import('./pages/sys-users/sys-users.module').then(m => m.SysUsersModule)
      },
      {
        path: 'timesheet',
        loadChildren: () => import('./pages/time-sheet/time-sheet.module').then(m => m.TimeSheetModule)
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./pages/sys-vehicles/sys-vehicles.module').then(m => m.SysVehiclesModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./pages/sys-customers/sys-customers.module').then(m => m.SysCustomersModule)
      },
      {
        path: 'quote',
        loadChildren: () => import('./pages/job-quotes/job-quotes.module').then(m => m.JobQuotesModule)
      },
      {
        path: 'quoteslist',
        loadChildren: () => import('./pages/job-quoteslist/job-quoteslist.module').then(m => m.JobQuotesListModule)
      },
      {
        path: 'jobtemplates',
        loadChildren: () => import('./pages/job-templates/job-templates.module').then(m => m.JobTemplatesModule)
      },
      {
        path: 'mechanichome',
        loadChildren: () => import('./pages/mechanic-home/mechanic-home.module').then(m => m.MechanicHomeModule)
      }
      ,
      {
        path: 'mechanicjobdetails',
        loadChildren: () => import('./pages/mechanic-jobdetails/mechanic-jobdetails.module').then(m => m.MechanicJobDetailsModule)
      },
      {
        path: 'connections',
        loadChildren: () => import('./pages/connections/connections.module').then(m => m.ConnectionsModule)
      },
      {
        path: 'business-profile',
        loadChildren: () => import('./pages/business-profile/business-profile.module').then(m => m.BusinessProfileModule)
      },
      {
        path: 'booking-requests',
        loadChildren: () => import('./pages/booking-requests/booking-requests.module').then(m => m.BookingRequestsModule)
      },
      // {
      //   path: 'email-templates',
      //   loadChildren: () => import('./pages/email-templates/email-templates.module').then(m => m.EmailTemplatesModule)
      // },
      {
        path: 'inventory',
        loadChildren: () => import('./pages/inventory/inventory.module').then(m => m.InventoryModule)
      }
    ]
  }, {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./pages/authentication/authentication.module').then(m => m.AuthenticationModule)
      }, {
        path: 'maintenance/offline-ui',
        loadChildren: () => import('./pages/maintenance/offline-ui/offline-ui.module').then(m => m.OfflineUiModule)
      }, {
        path: 'book',
        loadChildren: () => import('./pages/online-booking/online-booking.module').then(m => m.OnlineBookingModule)
      }
    ]
  }
];
